module.exports = __webpack_public_path__ + "img/1.8524c20.png";